import axios from 'axios';
import { baseUrl, baseUrl1 } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');

// ------------------------****Api Calls Outside the JobListingTables (fetchJob, saveData, activateOrDeactivate, retriggerJobAgain)****-------------------------//

export const fetchJob = async (pageNo: number, pageSize: number, brokerId: any, status: any, jobId: any, isCsr: boolean = false, isDashBoard: boolean = false) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            pageNo: String(pageNo),
            pageSize: String(pageSize),
            jobId: jobId || '',
            IsDashBoard: String(isDashBoard)
        });

        if (brokerId !== undefined && brokerId !== null && brokerId !== 'All' && brokerId !== -1) {
            params.append('brokerId', String(brokerId));
        }

        // Add status param only if valid number
        if (typeof status === 'number' && !isNaN(status)) {
            params.append('status', String(status));
        }

        params.append('IsCsr', String(isCsr));

        const response = await axios.get(`${baseUrl}api/job/getAllJobs?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const editJobByRowSelection = async (id: string) => {  // getApi to edit the job on click of Edit icon
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/job/getJobById?id=${id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in editing the selected job:', error);
        throw error;
    }
};

export const saveJob = async (selectedRow: any, isEditing: boolean) => {    // saveApi if any selected RowItem is updated or new Job creation
    try {
        const isEdit = !!isEditing;
        const payload = isEdit ? selectedRow : {
            ClientName: selectedRow?.ClientName || "",
            JobId: selectedRow?.JobId || "",
            JobOwner: selectedRow?.JobOwner || "",
            LobCode: selectedRow?.LobCode || "",
            JobTypeId: selectedRow?.JobTypeId || "",
            MacroFile: selectedRow?.MacroFile || "",
            MatchScore: selectedRow?.MatchScore || "",
            DispatchedOn: selectedRow?.DispatchedOn || "",
            IsActive: selectedRow?.IsActive || false,
            Status: selectedRow?.Status || false,
            CreatedOn: isEditing ? selectedRow?.CreatedOn : new Date().toISOString(),
            UpdatedOn: new Date().toISOString(),
        };

        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/job/addOrUpdateJob", payload, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating_Or_updating job:", error);
        throw error;
    }
};

export const AddLobRecord = async (lobAlias: any, lob: any, description: any) => {   //Mapping lob new records 
    try {
        const payload = {
            LOB_CODE: lobAlias,
            VCH_LOB: lob,
            VCH_POSSIBLE_LOB_NAME: description
        };

        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/job/AddLobAlias", payload, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }

    } catch (error) {
        console.error("Error in creating lob records:", error);
        throw error;
    }
}

export const activateAndDeactivateJobs = async (selectedRowIds: string[], status: boolean) => {    // Api to active and deactive the selected job rowItem
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        await Promise.all(
            selectedRowIds?.map(async (id) => {
                await axios.post(
                    `${baseUrl}api/job/activateOrDeactivateJob?id=${id}&status=${status}`,
                    {},
                    {
                        headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
                    }
                );
            })
        );
        return true;
    } catch (error) {
        console.error("Error updating job status:", error);
        throw error;
    }
};

export const triggerTheJobIdToCreateAgain = async (jobId: any, processType: string) => {  // Api call for re-trigger to create a new-jobid for already created existing onr
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl1 + `backgroundapi/Queue/CreateJobProcessByJobId?jobId=${jobId}&processName=${processType}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        return response;
    } catch (error) {
        console.error("Error in re-trigger for creating the job again:", error);
        throw error;
    }
};

// ------------------------------------------------------------------------------------------------------------------------------------------------------------//

// -------------------****Api Calls for JobId's status Activity Tables (viewActivityTbl, fetcherrorDetails, re-triggerActivityStatus)****----------------------//

export const viewJobActivityDetail = async (id: string) => {   // Api call to get created job status in activity table
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/job/GetActivityDetailByJobId?jobId=${id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching in activityDetails:', error);
        throw error;
    }
};


export const viewErrorForSelectedActivityName = async (id: string) => {  // Api call to view the error details msg in card for the activity failed
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/fileInfo/getErrorDetialsByjobid?job_id=${id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching error_Details:', error);
        throw error;
    }
};

export const retriggerTheFailedActivityStatusAgain = async (InstanceID: any, selectedJobIdforModel: any) => { // Api call for re-trigger the failed activty again for the jobid
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl1 + `backgroundapi/Queue/RetryJobActivityInstance?instanceId=${InstanceID}&id=${selectedJobIdforModel}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response;
        }
    } catch (error) {
        console.error('Error in re-trigger the activity:', error);
        throw error;
    }
};

// ------------------------------------------------------------------------------------------------------------------------------------------------------------//

// ------------------------------****Api Calls for uploaded InputFiles for download (viewInputFileTbl, downloadUplodedFiles)****-------------------------------//
export const viewUploadedFileRemarks = async (id: string) => {   // Api call for download the Remarks data
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/job/getJobById?id=${id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};


export const viewUploadedFileForDownload = async (id: string) => {   // Api call for download the uploaded files for the respesctive jobTypeId
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/fileInfo/getFileInfoByJobId?job_id=${id}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const getFilesFromS3OutputPath = async (jobId: string) => {   // Api call for get the files from Output Path
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/FileManager/GetFileFromOutputPath?jobid=${jobId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const generateURLForDownloadInputFiles = async (bucketName: string, filePath: string[]) => {   //Api call for download the input files uploaded from model
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const data = {
            "bucketName": bucketName,
            "fileName": filePath[1],
            "expiration": 300
        }
        const response = await axios.post(baseUrl + `api/FileManager/GetAuthorizedUrlByFileName`, data, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in downloading the selected inputFile:', error);
        throw error;
    }
};

export const ExportChecklistFile = async (bucketName: string, filePath: string[]) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const data = {
            "bucketName": bucketName,
            "fileName": filePath[0],
            "expiration": 300
        }
        const response = await axios.post(baseUrl + `api/FileManager/GetAuthorizedUrlByFileName`, data, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        // const response = await axios.get(baseUrl + `api/FileManager/GetAuthorizedUrlByFileName?bucketName=${bucketName}&fileName=${filePath[0]}&expiration=${30}`, {
        //     headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        // });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in downloading the selected inputFile:', error);
        throw error;
    }
};

export const DeleteJob = async (JobId: string) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(`${baseUrl}api/job/deleteJobId`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
            params: { job_id: JobId }
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error deleting the job:', error);
        throw error;
    }
};

export const UpdateJobStatus = async (JobId: string) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/job/UpdateJobStatus`,
            {},
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                },
                params: { job_id: JobId }
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error updating the jobid status:', error);
        throw error;
    }
};

export const fetchReprocessAutoJOBData = async (page: number = 1, folderName: string = "") => {
    try {
        // Generate token using your token process function
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        // Make the API request with the encoded folderName and page
        const response = await axios.get(
            `${baseUrl}api/job/GetDataForReprocessAutoJob?page=${page}&FolderName=${encodeURIComponent(folderName)}`,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        // Check for a successful response
        if (response.status === 200) {
            // Return the response data if successful
            return response.data;
        } else {
            console.error("Failed to fetch reprocess auto job data:", response.status);
            return { data: [], totalCount: 0 }; // Default empty response
        }
    } catch (error) {
        // Handle any errors in the API call
        console.error("Error in fetching reprocessAutojob_data:", error);
        return { data: [], totalCount: 0 }; // Return default structure on error
    }
};

export const ReprocessAutoJob = async (Jobid: string) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/job/ReProcessJob`,
            {},
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                },
                params: { job_id: Jobid }
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error reprocessing the jobid:', error);
        throw error;
    }
};

export const DispatchJobId = async (JobId: string) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.post(
            `${baseUrl}api/job/dispatchJob`,
            {},
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                },
                params: { job_id: JobId }
            }
        );

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error dispatching the job:', error);
        throw error;
    }
};

export const getAdminAccessforUser = async (userName: string, token: any) => {   // Api call for find whether user is adminAccess
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        if (sessionStorage.getItem("UserRole")) {
            return JSON.parse(sessionStorage.getItem("UserRole") || "{}");

        }
        const response = await axios.get(baseUrl + `api/master/getuserbyroles?userName=${userName}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            sessionStorage.setItem("UserRole", response?.data && typeof response?.data === 'object' ? JSON.stringify(response?.data) : "");
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const tranferJob = async (Id: string, JobId: string, broker_id: any) => {   // Api call for find whether user is adminAccess
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const data = {
            "job_id": JobId,
            "broker_id": broker_id
        }
        const response = await axios.post(baseUrl + "api/job/TranferJob", data, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const fetchJobFailedRecords = async (pageNo: any, pageSize: any, brokerId: any, fromDate: any, toDate: any, folderName: any, reason: any) => {    // getApi to fetchData
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/job/JobFailedRecords?`;

        if (brokerId) {
            url += "brokerId=" + encodeURIComponent("" + brokerId) + "&";
        }

        if (fromDate) {
            url += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        }

        if (toDate) {
            url += "toDate=" + encodeURIComponent("" + toDate) + "&";
        }

        if (pageNo) {
            url += "pageNumber=" + encodeURIComponent("" + pageNo) + "&";
        }

        if (pageSize) {
            url += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        }

        if (folderName) {
            url += "folderName=" + encodeURIComponent("" + folderName) + "&";
        }
        if (reason) {
            url += "reason=" + encodeURIComponent("" + reason) + "&";
        }
        url = url.replace(/[?&]$/, "");

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    }
    catch (error) {
        console.error('Error fetching productiondata:', error);
        throw error;
    }
}

export const generateExportExcelforAutoJobFailedList = async (broker_id: any, folderName: string, from_date: any, toDate: any, reason: any) => {   //Api call for exportExcel csr_roleDashboard

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/job/ExportJobFailedRecords?`;

        if (broker_id) {
            url += "brokerId=" + encodeURIComponent("" + broker_id) + "&";
        }

        if (from_date) {
            url += "fromDate=" + encodeURIComponent("" + from_date) + "&";
        }

        if (toDate) {
            url += "toDate=" + encodeURIComponent("" + toDate) + "&";
        }

        if (folderName) {
            url += "folderName=" + encodeURIComponent("" + folderName) + "&";
        }

        if (reason) {
            url += "reason=" + encodeURIComponent("" + reason) + "&";
        }
        url = url.replace(/[?&]$/, "");

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading csrRoleExportData:', error);
        throw error;
    }
};

export const getAutoDispatcherJobsList = async (pageNo: number = 0, pageSize: number = 100, statusId: number = 0, jobId: string = "") => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token'));

        const response = await axios.get(baseUrl + `api/job/AutoDispatchJobs?pageNo=${pageNo}&pageSize=${pageSize}&statusId=${statusId}&jobId=${jobId || ""}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching the uploaded file_Info:', error);
        throw error;
    }
};

export const updateDispatchStatusByJobId = async (JobId: string, dispatchFlag: boolean = false) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(`${baseUrl}api/job/EnableOrDisableAutoDispatchStatus?jobId=${JobId}&enable=${dispatchFlag}`,
            {},
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                },
                params: { job_id: JobId }
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error updating the jobid status:', error);
        throw error;
    }
};


export const getAutoDispatchJobReport = async () => {   //Api call for exportExcel csr_roleDashboard

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/Report/getAutoDispatchJobReport`;

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading csrRoleExportData:', error);
        throw error;
    }
};

export const RetryAutoDispatcherFailedJobs = async (jobId: string) => {   //Api call for exportExcel csr_roleDashboard

    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const param = new URLSearchParams({});
        if (jobId) {
            param.append("jobId", jobId.toString());
        }
        let url = `${baseUrl}api/job/RetryAutoDispatcherFailedJobs?${param.toString()}`;
        const response = await axios.put(url, null, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error in downloading csrRoleExportData:', error);
        throw error;
    }
};
